import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ForgottenpswdPage } from './forgottenpswd.page';

const routes: Routes = [
  {
    path: '',
    component: ForgottenpswdPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ForgottenpswdPageRoutingModule {}
